import { render, staticRenderFns } from "./DynamicAttributeConfiguration.vue?vue&type=template&id=67ea659f&"
import script from "./DynamicAttributeConfiguration.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports